import axios from 'axios'

export const fetchBranchs = async() => {
  try {
    return await axios.get(`branchs`)
  } catch (error) {
    throw error.response
  }
}

export const fetchBranch = async(id) => {
  try {
    return await axios.get(`branchs/${id}`)
  } catch (error) {
    throw error.response
  }
}
